var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 11,
    viewBox: "0 0 16 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.6116 6.24995H1.25C1.03718 6.24995 0.858983 6.17816 0.7154 6.03458C0.5718 5.891 0.5 5.7128 0.5 5.49998C0.5 5.28716 0.5718 5.10896 0.7154 4.96538C0.858983 4.8218 1.03718 4.75001 1.25 4.75001H12.6116L9.3192 1.45765C9.17048 1.30894 9.09709 1.1349 9.09902 0.935554C9.10094 0.736204 9.17433 0.558963 9.3192 0.403829C9.47433 0.248713 9.65253 0.168588 9.8538 0.163455C10.0551 0.158321 10.2333 0.233321 10.3884 0.388455L14.8672 4.8673C14.9608 4.96089 15.0269 5.05961 15.0653 5.16346C15.1038 5.26729 15.123 5.37946 15.123 5.49998C15.123 5.6205 15.1038 5.73267 15.0653 5.8365C15.0269 5.94035 14.9608 6.03907 14.8672 6.13266L10.3884 10.6115C10.2397 10.7602 10.0631 10.8336 9.85863 10.8317C9.65414 10.8298 9.47433 10.7512 9.3192 10.5961C9.17433 10.441 9.09933 10.2654 9.0942 10.0692C9.08908 9.87305 9.16408 9.69742 9.3192 9.5423L12.6116 6.24995Z",
    fill: "#282F44"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow);
export default __webpack_public_path__ + "static/media/arrow.0d271c22453573cfd3c3b52ee307c4c1.svg";
export { ForwardRef as ReactComponent };